import axios from "axios";

export let headers = {
	"Tenant-Access-Token": "ZDcyOTY4MzUwODU5MWE2NTUwOGE0ZjhkYjc2ZmVmNzc=",
	"Tenant-Access-Key": "Mta07mNltnjRmQ",
};

export const BASE_URL = "https://immersive-game-india.confirmu.com";

export const api = axios.create({
	baseURL: BASE_URL,
	headers,
});